// Action types with request, success, and failure states
export const patientProfileCompletionActions = {
  CHECK_PROFILE_COMPLETION: {
    REQUEST: 'patient-profile/CHECK_COMPLETION_REQUEST',
    SUCCESS: 'patient-profile/CHECK_COMPLETION_SUCCESS',
    FAILURE: 'patient-profile/CHECK_COMPLETION_FAILURE'
  },
  CLEAR_PROFILE_COMPLETION: 'patient-profile/CLEAR_COMPLETION_STATUS'
};

/**
 * Action creator to clear profile completion status
 * @returns {Object} Action object
 */
export const clearProfileCompletionStatus = () => ({
  type: patientProfileCompletionActions.CLEAR_PROFILE_COMPLETION
});
